/** Block id of the page title: the first block of every page document, on every platform. */
export const PAGE_TITLE_BLOCK_ID = 'page-title'
